import React from "react";
import { useLottie } from "lottie-react";
import PropTypes from "prop-types";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const getSize = (size, height, width) => {
  if (size === "small") {
    return {
      height: "150px",
      width: "auto",
    };
  }
  return {
    height: height,
    width: width,
  };
};

const getFileType = (input) => {
  if (input instanceof File) {
    const name = input.name.toLowerCase();
    if (name.endsWith(".lottie")) return "lottie";
    if (name.endsWith(".json")) return "json";
  }

  if (typeof input === "object") {
    return "json";
  }

  return "unknown";
};

const Lotties = ({
  file,
  size,
  loop = true,
  height = "250px",
  width = "auto",
  autoplay = true,
}) => {
  const options = {
    animationData: file,
    loop: loop,
  };
  const dimensions = getSize(size, height, width);

  const { View } = useLottie(options, getSize(size, height, width));

  return (
    <>
      {getFileType(file) === "json" ? (
        View
      ) : (
        <DotLottieReact
          src={file}
          loop={loop}
          autoplay={autoplay}
          style={{
            height: dimensions.height,
            width: dimensions.width,
          }}
        />
      )}
    </>
  );
};

Lotties.propTypes = {
  file: PropTypes.any,
  size: PropTypes.string,
  loop: PropTypes.bool,
};

export default Lotties;
